import { parse } from 'query-string';

export const getPage = (page, location) => {
  const query = location && parse(location.search);
  const defaultPage = query && query.page ? query.page : 1;

  return page ? page : defaultPage;
}
